import React, { useState, useMemo } from 'react';

import { useQuery } from 'react-query';
import { LectureChangeLogService } from 'services/core';

import Spinner from '@core/components/spinner/Spinner';

import ErrorSvg from 'assets/images/empty-search.svg';

import classes from './LectureChangeLog.module.scss';

const LectureChangeLog = ({ id }) => {
	const [page_size] = useState(5);
	const [page, setPage] = useState(1);
	const { data, isLoading, error } = useQuery(['lecture-changelog', id, page], () =>
		LectureChangeLogService({ id, page_size, page })
	);
	const pagesNumbers = useMemo(
		() =>
			data?.data?.count &&
			Array.from(Array(Math.ceil(data?.data?.count / page_size)), (_, i) => i + 1),
		[data?.data?.count, page_size]
	);
	// console.log(someData, '<<<<< SOME DATA HER E');
	return (
		<>
			{data && !isLoading && !error ? (
				<>
					<ul className={`${classes['changelog-wrapper']}`}>
						{data?.data?.results?.map((version, index) => (
							<li className="p-4" key={version.version_string + index}>
								<h3>{version.version_string}</h3>
								<ul className={`d-flex flex-column gap-1`}>
									{version.changelogs?.map((log, index) => (
										<li key={index}>{log.text}</li>
									))}
								</ul>
								<span>{version.release_date}</span>
							</li>
						))}
					</ul>
					{pagesNumbers?.length > 1 && (
						<div
							className={`${classes['pagination-button']} d-flex flex-row justify-content-center gap-2`}>
							{pagesNumbers.map((pageNumber) => (
								<button
									key={pageNumber}
									onClick={() => setPage(pageNumber)}
									disabled={pageNumber === +page}>
									{pageNumber}
								</button>
							))}
						</div>
					)}
				</>
			) : (
				<>
					{isLoading && !error ? (
						<div className="d-flex align-items-center justify-content-center my-5 py-5">
							<Spinner />
						</div>
					) : (
						<div
							className={`${classes['changelog-error']} d-flex flex-column align-items-center justify-content-center w-100`}>
							<ErrorSvg />
							<h1>Oh oh!</h1>
							<p>Something went wrong! please reload the page.</p>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default LectureChangeLog;
